import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  width: "100%"
}));

export const InputPill = styled(Box)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.customColors.systemPrimary01,
  border: `1px solid ${theme.customColors.inputBorder}`,
  borderRadius: "8px",
  display: "flex",
  flexGrow: 1,
  paddingBottom: "8px",
  paddingLeft: "20px",
  paddingRight: "20px",
  paddingTop: "8px"
}));
